'use client'

import { Button } from '@inflow/ui/components/button';
import { useBreakpoints } from '@inflow/ui/lib/useBreakpoints';
import { useAtomValue } from 'jotai';
import HeroContainer from '../../components/HeroContainer';
import HeroTitle from '../../components/HeroTitle';
import { NavLink } from '../../components/NavLink';
import { latestResearchAtom } from '../../state/latestResearchAtom';

export default function Hero() {
  const { lg } = useBreakpoints()
  const { isLoading } = useAtomValue(latestResearchAtom)
  return (
    <HeroContainer>
      <div className='max-w-xl md:max-w-full'>
        <HeroTitle
          desktopAlignment='center'
          title={<>Navigate complexity with clarity</>}
          subTitle={
            <>Independent, data-driven insights from Gerard Minack trusted by institutions worldwide for 35 years</>
          }
        >
          {/* <NavLink href="/research">
            <Button size="lg">Research</Button>
          </NavLink> */}
          <NavLink href="/contact">
            <Button size="lg">Contact</Button>
          </NavLink>
        </HeroTitle>
      </div>

      {/* {isLoading ? (
        <div className="flex h-[300px] items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <motion.div
          className='flex w-full justify-center lg:justify-end'
          key={lg ? 'desktop' : 'mobile'}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut', delay: 1 }}
        >
          {lg ? <ResearchCardsDesktop /> : <ResearchCards />}
        </motion.div>
      )} */}
    </HeroContainer>
  )
}
